import { Alert, Button, Text } from '@nimbus-ds/components';
import { useNavegate } from 'App/hooks';
import { useDismissibleComponent } from 'commons/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling/useTranslationBilling';

export default function ConsumidorFinalAlert() {
  const t = useTranslationBilling(
    'checkout.plansAndSubscriptions.accountData.consumidorFinalAlert',
  );
  const { goTo } = useNavegate();
  const handleLoadInvoiceInfo = () => goTo('/account/invoices/info');
  const { dismiss, shouldShow } = useDismissibleComponent(
    `${ConsumidorFinalAlert.name}`,
  );

  return (
    <Alert
      appearance="primary"
      title={t('title')}
      show={shouldShow}
      onRemove={dismiss}
    >
      <Text>{t('message')}</Text>
      <Button onClick={handleLoadInvoiceInfo}>{t('buttonMessage')}</Button>
    </Alert>
  );
}
